import { Fragment, useCallback } from 'react';
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';
import { helpScoutArticle } from 'src/utils/helpscoutBeacon';
import { LinkButton } from 'styles-js/buttons';
import Icon from 'src/components/icon';

type Props = {
  onFinish: (acceptResearch?: boolean) => void;
}

export default function ResearchOptInScreen({ onFinish }: Props) {

  const onLearnMore = useCallback(() => {
    helpScoutArticle('154-opportunities-by-email', { type: 'modal' });
    trackFootfallEvent(Event.CLICKED, { clickType: 'join-research-learn-more' });
  }, []);

  const onOptOut = useCallback(() => onFinish(false), [onFinish]);

  return (
    <Fragment>
      <p><strong>{i18n.t('May we send you occasional emails about opportunities that might interest you?')}</strong></p>
      <p>{i18n.t('e.g. surveys, clinical trials, paid market research, new patient communities')}</p>
      <div className="signup-box__tips">
        <p>
          {i18n.t('It will always be HealthUnlocked that contacts you. And you can opt out at any time.')}
          {' '}
          <LinkButton onClick={onLearnMore}>
            {i18n.t('Learn more')} <Icon icon={'right-open'} />
          </LinkButton>
        </p>
        <StyledLinkButton onClick={onOptOut}>
          {i18n.t('No, do not email me these opportunities')}
        </StyledLinkButton>
      </div>
    </Fragment>
  );
}

const StyledLinkButton = styled(LinkButton)`
  margin-top: 20px;
`;
